import { render, staticRenderFns } from "./CloseAccount.vue?vue&type=template&id=06a8fd2e&scoped=true&"
import script from "./CloseAccount.vue?vue&type=script&lang=js&"
export * from "./CloseAccount.vue?vue&type=script&lang=js&"
import style0 from "./CloseAccount.vue?vue&type=style&index=0&id=06a8fd2e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a8fd2e",
  null
  
)

export default component.exports